import React from 'react';
import { Link } from 'react-router-dom';
import { FiChevronDown, FiChevronRight, FiExternalLink } from 'react-icons/fi';
import styled from 'styled-components';
import NiceWrapper from 'components/NiceWrapper';
import { Box, Flex, Button } from 'rebass';
import { Textarea } from '@rebass/forms';
import { ProductFeedbackModal } from 'components/ProductFeedbackModal';
import config from 'config';
import auth from 'services/auth';
import { HeaderLink, HeaderButton } from './HeaderLink';
import NavBar from './NavBar';
import { EVENT_API_DOWN, MESSAGE_503_MAINTENANCE, EVENT_API_LOGGED_OUT } from 'utils/constants';
import EventEmitter from 'utils/events';
import helpers from 'utils/helpers';
import xhr from 'xhr.js';
import services from 'services/services';
import OutsideClickHandler from 'react-outside-click-handler';
import NiceModal from '../NiceModal';
import store from 'store';
import ReactMarkdown from 'react-markdown';

const FEATURE_UPDATES_CACHE_KEY = 'pfx_feat_up';

const headerLinkClassName =
    'flex py-2 px-4 m-0 no-underline antialiased select-none cursor-pointer outline-none color-text-primary uppercase transition-colors relative bold fs-12 leading-[22px] h-auto hover:color-primary';

const greenCircle = props => {
    props = props || {};
    let margin = props.margin ? props.margin : 0;
    return (
        <span
            className="fill-green"
            style={{
                display: 'inline-block',
                width: '12px',
                height: '12px',
                borderRadius: '50%',
                verticalAlign: 'top',
                margin: margin
            }}
        ></span>
    );
};

/*const HeaderWrapper = styled.div`
    display: flex;
    height: 100vh;
    left: 0px;
    position: sticky;
    top: 0px;
    z-index: 2;
`;*/

const HeaderWrapper = styled.div`
    display: block;
`;

const HeaderWidthWrapper = styled.div`
    background-color: transparent;
    flex-grow: 1;
    position: relative;
    transition: width 150ms;
    padding: 0 36px;
    border-bottom: 1px solid #e9e9e9;
`;

class Header extends React.Component {
    constructor(props) {
        super(props);

        //console.log(this.props.routeMatch);

        let updates_last_checked = store.get(FEATURE_UPDATES_CACHE_KEY);

        this.state = {
            subMenuExpanded: false,
            updatesExpanded: false,
            helpSubmenuExpanded: false,
            accountSwitcherExpanded: false,
            api_down: false,
            logged_out: false,
            showFeatureUpdatesAlert: false,
            updates_last_checked: updates_last_checked,
            featureUpdates: []
        };

        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.handleSubmenuExpand = this.handleSubmenuExpand.bind(this);
        this.handleUpdatesExpand = this.handleUpdatesExpand.bind(this);
        this.handleHelpExpand = this.handleHelpExpand.bind(this);
        this.accountSwitcherOnMouseEnter = this.accountSwitcherOnMouseEnter.bind(this);
        this.accountSwitcherOnMouseOut = this.accountSwitcherOnMouseOut.bind(this);
        this.accountSwitcherTimeout = null;
        this.submitFeedback = this.submitFeedback.bind(this);
        this.shouldShowFeatureUpdatesAlert = this.shouldShowFeatureUpdatesAlert.bind(this);
    }

    shouldShowFeatureUpdatesAlert(updates_last_checked) {
        //console.log('updates_last_checked', updates_last_checked)
        let showFeatureUpdatesAlert = false;
        if (!updates_last_checked) {
            showFeatureUpdatesAlert = true;
        } else {
            //console.log(FEATURE_UPDATES[0].timestamp, updates_last_checked);
            //console.log(FEATURE_UPDATES[0].timestamp > updates_last_checked);
            if (this.state.featureUpdates[0] && this.state.featureUpdates[0].timestamp > updates_last_checked) {
                showFeatureUpdatesAlert = true;
            }
        }
        return showFeatureUpdatesAlert;
    }

    accountSwitcherOnMouseEnter() {
        if (this.accountSwitcherTimeout) {
            clearTimeout(this.accountSwitcherTimeout);
        }
        this.setState({ accountSwitcherExpanded: true });
    }

    accountSwitcherOnMouseOut() {
        const that = this;
        this.accountSwitcherTimeout = setTimeout(function() {
            that.setState({ accountSwitcherExpanded: false });
        }, 300);
    }

    handleSubmenuExpand() {
        const newVal = !this.state.subMenuExpanded;
        this.setState({ subMenuExpanded: newVal });
    }

    handleUpdatesExpand() {
        const newVal = !this.state.updatesExpanded;
        helpers.storeSave(FEATURE_UPDATES_CACHE_KEY, Date.now());

        const showFeatureUpdatesAlert = this.shouldShowFeatureUpdatesAlert(Date.now());

        this.setState({ updatesExpanded: newVal, showFeatureUpdatesAlert: showFeatureUpdatesAlert });
    }

    handleHelpExpand() {
        const newVal = !this.state.helpSubmenuExpanded;

        this.setState({ helpSubmenuExpanded: newVal });
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);

        EventEmitter.subscribe(EVENT_API_DOWN, data => {
            this.setState({ api_down: true });
        });
        EventEmitter.subscribe(EVENT_API_LOGGED_OUT, data => {
            this.setState({ logged_out: true });
        });

        services.productUpdates().then(res => {
            this.setState({ featureUpdates: res }, () => {
                let showFeatureUpdatesAlert = this.shouldShowFeatureUpdatesAlert(this.state.updates_last_checked);
                this.setState({ showFeatureUpdatesAlert });
            });
        });
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    handleClickOutside(event) {
        if (
            this.wrapperRef &&
            !this.wrapperRef.contains(event.target) &&
            !document.getElementById('account-submenu').contains(event.target)
        ) {
            this.setState({ subMenuExpanded: false });
        }
    }

    toggleWidth() {
        const newToggle = this.state.headerExpanded == 'expanded' ? 'collapsed' : 'expanded';
        this.setState({ headerExpanded: newToggle });
    }

    getSelectedAccountName() {
        let an = '';
        this.props.auth.user.accounts.forEach(account => {
            if (account.id == this.props.auth.account.id) {
                an = account.title;
            }
        });
        return an;
    }

    chooseAccount(id) {
        auth.changeAccountId(id);
    }

    renderUpdates() {
        try {
            let ret = '';
            if (this.state.updatesExpanded) {
                const niceWrapperStyle = {
                    position: 'absolute',
                    top: '48px',
                    right: '16px',
                    background: '#fff',
                    height: 'auto',
                    padding: '0',
                    overflow: 'auto',
                    zIndex: 101,
                    boxShadow:
                        '0px 17px 100px rgba(0, 0, 0, 0.06), 0px 5.125px 30.1471px rgba(0, 0, 0, 0.0390953), 0px 2.12866px 12.5216px rgba(0, 0, 0, 0.03), 0px 0.769896px 4.5288px rgba(0, 0, 0, 0.0209047)',
                    width: '380px'
                };

                ret = (
                    <NiceWrapper style={niceWrapperStyle}>
                        <Box
                            className="text-primary"
                            sx={{ padding: '24px', fontSize: '18px', lineHeight: '22px', fontWeight: '600' }}
                        >
                            Product Updates
                        </Box>
                        <hr />

                        <Box sx={{ overflow: 'auto', maxHeight: 'calc(100vh - 160px)', paddingTop: '16px' }}>
                            {this.state.featureUpdates.map((feature, index) => {
                                return (
                                    <Box
                                        sx={{ padding: '0 24px 16px 24px', lineHeight: '32px' }}
                                        id={`feature-update-${index}-container`}
                                    >
                                        <Flex
                                            className="text-primary bold pointer"
                                            justifyContent="space-between"
                                            onClick={() => {
                                                const el = document.getElementById(`feature-update-${index}-body`);
                                                if (el.style.display === 'none') {
                                                    el.style.display = 'block';
                                                } else {
                                                    el.style.display = 'none';
                                                }
                                            }}
                                        >
                                            <Box style={{ lineHeight: '20px' }}>
                                                {feature.timestamp > this.state.updates_last_checked
                                                    ? greenCircle({ margin: '4px 4px 0 0' })
                                                    : ''}{' '}
                                                {feature.title}
                                                <span
                                                    style={{
                                                        display: 'block',
                                                        fontSize: '11px',
                                                        fontWeight: 400,
                                                        color: '#b0b0b0',
                                                        letterSpacing: '0.02em',
                                                        lineHeight: '16px',
                                                        marginTop: '1px'
                                                    }}
                                                >
                                                    {new Date(feature.timestamp).toLocaleDateString('en-US', {
                                                        month: 'short',
                                                        day: 'numeric',
                                                        year: 'numeric'
                                                    })}
                                                </span>
                                            </Box>
                                            <Box>
                                                <FiChevronDown style={{ fontSize: '16px' }} />
                                            </Box>
                                        </Flex>
                                        <Box
                                            id={`feature-update-${index}-body`}
                                            className="feature-update-body text-secondary"
                                            style={
                                                feature.timestamp > this.state.updates_last_checked
                                                    ? {}
                                                    : { display: 'none' }
                                            }
                                        >
                                            <ReactMarkdown linkTarget="_blank" source={feature.body} />
                                        </Box>
                                    </Box>
                                );
                            })}
                        </Box>
                    </NiceWrapper>
                );
            }
            return (
                <OutsideClickHandler
                    onOutsideClick={() => {
                        this.setState({ updatesExpanded: false });
                    }}
                >
                    {ret}
                </OutsideClickHandler>
            );
        } catch (e) {
            helpers.trackError(e);
        }
    }

    renderHelpSubmenu() {
        try {
            let ret = '';
            if (this.state.helpSubmenuExpanded) {
                const niceWrapperStyle = {
                    position: 'absolute',
                    top: '48px',
                    right: '16px',
                    background: '#fff',
                    height: 'auto',
                    padding: '8px 0',
                    zIndex: 101,
                    boxShadow:
                        '0px 17px 100px rgba(0, 0, 0, 0.06), 0px 5.125px 30.1471px rgba(0, 0, 0, 0.0390953), 0px 2.12866px 12.5216px rgba(0, 0, 0, 0.03), 0px 0.769896px 4.5288px rgba(0, 0, 0, 0.0209047)',
                    width: '180px'
                };

                ret = (
                    <NiceWrapper style={niceWrapperStyle}>
                        <a
                            href="https://help.dscout.com/hc/en-us/categories/37025732228756-Private-Panels"
                            target="_blank"
                            rel="noopener noreferrer"
                            className={headerLinkClassName}
                        >
                            <span className="grow">
                                Knowledge Base{' '}
                                <FiExternalLink
                                    style={{
                                        float: 'right',
                                        margin: '3px 0 0 0',
                                        verticalAlign: 'top',
                                        height: '14px'
                                    }}
                                />
                            </span>
                        </a>
                        <HeaderButton
                            className="headerLinkDropdown"
                            onClick={() => {
                                this.setState({ showModalProductFeedback: true, helpSubmenuExpanded: false });
                            }}
                        >
                            Product Feedback
                        </HeaderButton>
                        <HeaderButton
                            className="headerLinkDropdown"
                            onClick={() => {
                                helpers.openSupportChat();
                            }}
                        >
                            Contact Us
                        </HeaderButton>
                    </NiceWrapper>
                );
            }
            return (
                <OutsideClickHandler
                    onOutsideClick={() => {
                        this.setState({ helpSubmenuExpanded: false });
                    }}
                >
                    {ret}
                </OutsideClickHandler>
            );
        } catch (e) {
            helpers.trackError(e);
        }
    }

    renderSubmenu() {
        const baseURL = config.API_URL;

        const accounts = this.props.auth.user.accounts
            .sort((a, b) => a.title.localeCompare(b.title))
            .map(account => {
                if (account.id == this.props.auth.account.id) {
                    return (
                        <HeaderButton
                            key={account.id}
                            className="nav-item-active headerLinkDropdown"
                            onClick={() => {
                                this.chooseAccount(account.id);
                            }}
                        >
                            {account.title}
                        </HeaderButton>
                    );
                }
                return (
                    <HeaderButton
                        key={account.id}
                        onClick={() => {
                            this.chooseAccount(account.id);
                        }}
                        variant="secondary"
                        className="headerLinkDropdown"
                    >
                        {account.title}
                    </HeaderButton>
                );
            });

        const niceWrapperStyle = {
            position: 'absolute',
            top: '48px',
            right: '36px',
            background: '#fff',
            height: 'auto',
            padding: 0,
            overflow: 'visible',
            zIndex: 101
        };
        let ret = '';
        if (this.state.subMenuExpanded) {
            ret = (
                <NiceWrapper style={niceWrapperStyle} ref={this.setWrapperRef}>
                    <Flex
                        style={{
                            padding: '16px 40px 16px 16px',
                            background: '#F6F6F6',
                            borderTopLeftRadius: '8px',
                            borderTopRightRadius: '8px',
                            maxWidth: '260px'
                        }}
                    >
                        {this.props.auth.user.avatar && (
                            <Box mr={2} flexShrink={0}>
                                <img
                                    src={this.props.auth.user.avatar}
                                    style={{
                                        width: '32px',
                                        height: '32px',
                                        borderRadius: '50%'
                                    }}
                                    alt="Avatar"
                                />
                            </Box>
                        )}
                        <Box sx={{ whiteSpace: 'nowrap', lineHeight: '16px' }}>
                            <div className="text-primary fs-14 ellipsis">{this.props.auth.user.name}</div>
                            <div className="text-secondary fs-12 ellipsis">{this.props.auth.user.email}</div>
                            <div className="text-secondary fs-12 ellipsis">{this.props.auth.account.title}</div>
                        </Box>
                    </Flex>

                    <HeaderLink to="/me" className="headerLinkDropdown" style={{ marginTop: '8px' }}>
                        <span className="textStyle">User Settings</span>
                    </HeaderLink>

                    {/* <HeaderLink to="/billing">
                        <span className="textStyle">Plan and billing</span>
                    </HeaderLink>

                    <HeaderLink to="/settings">
                        <span className="textStyle">Organization Settings</span>
                    </HeaderLink> */}

                    {this.props.auth.user.accounts.length > 1 ? (
                        <HeaderButton
                            className="link-accountSwitcher headerLinkDropdown"
                            onMouseEnter={this.accountSwitcherOnMouseEnter}
                            onMouseLeave={this.accountSwitcherOnMouseOut}
                        >
                            <span className="textStyle">Switch organization</span>
                            <span className="iconEnd">
                                <FiChevronRight style={{ strokeWidth: '1.5px' }} />
                            </span>
                            {this.state.accountSwitcherExpanded ? (
                                <NiceWrapper className="accountSwitcher">{accounts}</NiceWrapper>
                            ) : (
                                ''
                            )}
                        </HeaderButton>
                    ) : (
                        ''
                    )}

                    <HeaderButton
                        className="headerLinkDropdown"
                        style={{ color: 'red', marginBottom: '8px' }}
                        onClick={() => {
                            window.zE('webWidget', 'identify', {
                                name: '',
                                email: ''
                            });
                            auth.clearStorage();
                            window.location = `${baseURL}/logout`;
                        }}
                    >
                        Logout
                    </HeaderButton>
                </NiceWrapper>
            );
        }
        return ret;
    }

    submitFeedback(e) {
        e.preventDefault();

        const email = this.props.auth.user.email;
        const message = document.getElementById('feedback-message').value;

        xhr.post(`/collect-feedback`, { email, message }, { withCredentials: true })
            .then(() => {
                alert('Thank you!');
                this.setState({ showModalFeedback: false });
            })
            .catch(error => {
                const errorText = services.parseAndTrackXhrErrors(error);
                alert(errorText);
            });
    }

    render() {
        const days_until_trial_expires = helpers.daysUntilTrialExpires(this.props.auth.account);

        return (
            <>
                {this.state.api_down == true ? (
                    <Box fontSize={1} className="bg-error sticky-top-banner" p={3} px={4}>
                        {MESSAGE_503_MAINTENANCE}
                    </Box>
                ) : (
                    <></>
                )}
                {this.state.logged_out == true ? (
                    <Box fontSize={1} className="bg-warning sticky-top-banner" p={3} px={4} sx={{ color: 'black' }}>
                        Your login session has expired, please <Link to={`/login`}>Log In</Link> again.
                    </Box>
                ) : (
                    <></>
                )}
                {helpers.isTrialExpired(this.props.auth.account) == true ? (
                    <Box
                        fontSize={1}
                        className="bg-warning sticky-top-banner"
                        p={3}
                        px={4}
                        sx={{ color: 'black', fontWeight: '600' }}
                    >
                        Your trial has expired - please contact{' '}
                        <a href={`mailto:${config.SUPPORT_EMAIL}`}>{config.SUPPORT_EMAIL}</a> to upgrade or extend.
                    </Box>
                ) : (
                    <></>
                )}
                <HeaderWrapper>
                    <HeaderWidthWrapper>
                        <NavBar>
                            <Flex>
                                {/* <HeaderLink to="/settings">
                                    <span className="iconWrapper">
                                        <FiUserPlus />
                                    </span>
                                    <span className="textStyle">Recruit</span>
                                </HeaderLink>
                                <HeaderLink to="/dashboard">
                                    <span className="iconWrapper">
                                        <FiHome />
                                    </span>
                                    <span className="textStyle">Home</span>
                                </HeaderLink> */}
                                <HeaderButton
                                    style={{ marginLeft: 0, marginRight: '36px', paddingLeft: 0, paddingRight: 0 }}
                                >
                                    <Link to="/studies">
                                        <img
                                            style={{ marginLeft: '-3px' }}
                                            height="20"
                                            src={`${config.UI_SUFFIX}/dscout-private-panels-logo.svg`}
                                        />
                                    </Link>
                                </HeaderButton>

                                <HeaderLink to="/studies" style={{ marginRight: '32px' }}>
                                    <span className="textStyle">Studies</span>
                                </HeaderLink>
                                <HeaderLink
                                    to="/panel"
                                    style={{ marginRight: '32px' }}
                                    isActive={(match, location) => {
                                        return (
                                            match ||
                                            helpers.startsWithAny(
                                                ['/panels', '/panel-data', '/panel-incentives'],
                                                location.pathname
                                            )
                                        );
                                    }}
                                >
                                    <span className="textStyle">Panels</span>
                                </HeaderLink>
                                <HeaderLink to="/settings">
                                    <span className="textStyle">Settings</span>
                                </HeaderLink>
                                {/* <HeaderLink to="/search">
                                    <span className="iconWrapper">
                                        <FiSearch />
                                    </span>
                                    <span className="textStyle">Search</span>
                                </HeaderLink> */}
                            </Flex>
                            <Flex>
                                {days_until_trial_expires !== false && (
                                    <HeaderButton
                                        style={{ marginRight: '40px' }}
                                        onClick={() => {
                                            window.zE('webWidget', 'open');
                                        }}
                                    >
                                        <u>
                                            {days_until_trial_expires} {days_until_trial_expires == 1 ? 'day' : 'days'}{' '}
                                            left in your trial
                                        </u>
                                    </HeaderButton>
                                )}

                                <Box sx={{ position: 'relative' }}>
                                    <HeaderButton
                                        onClick={this.handleUpdatesExpand}
                                        id="updates-submenu"
                                        style={{ marginRight: '32px' }}
                                    >
                                        <span className="textStyle">
                                            {this.state.showFeatureUpdatesAlert
                                                ? greenCircle({ margin: '4px 4px 0 0' })
                                                : ''}
                                            Updates
                                            <FiChevronDown
                                                style={{
                                                    margin: '5px 0 3px 4px',
                                                    verticalAlign: 'top',
                                                    width: '16px'
                                                }}
                                            />
                                        </span>
                                    </HeaderButton>
                                    {this.renderUpdates()}
                                </Box>

                                <Box sx={{ position: 'relative' }} ml={1}>
                                    <HeaderButton
                                        onClick={this.handleHelpExpand}
                                        id="updates-submenu"
                                        style={{ marginRight: '32px' }}
                                    >
                                        <span className="textStyle">
                                            Help
                                            <FiChevronDown
                                                style={{ margin: '5px 0 3px 4px', verticalAlign: 'top', width: '16px' }}
                                            />
                                        </span>
                                    </HeaderButton>
                                    {this.renderHelpSubmenu()}
                                </Box>

                                <HeaderButton onClick={this.handleSubmenuExpand} id="account-submenu">
                                    <Flex ml={2} style={{ justifyContent: 'space-between', width: '100%' }}>
                                        <Flex>
                                            {this.props.auth.user.avatar ? (
                                                <Box mr={2}>
                                                    <img
                                                        src={this.props.auth.user.avatar}
                                                        style={{
                                                            width: '24px',
                                                            height: '24px',
                                                            borderRadius: '50%'
                                                        }}
                                                    />
                                                </Box>
                                            ) : (
                                                <></>
                                            )}

                                            {/*(
                                                    <Box style={{
                                                                width: '24px',
                                                                height: '24px',
                                                                borderRadius: '50%',
                                                                background: '#fff',
                                                                textAlign: 'center'
                                                            }}
                                                        >
                                                        {this.props.auth.user.name.split('')[0]}
                                                    </Box>
                                                )*/}
                                            <Box flexShrink={0} className="ellipsis" lineHeight="24px">
                                                {this.props.auth.user.name}
                                            </Box>
                                        </Flex>
                                        <FiChevronDown
                                            style={{ margin: '5px 0 3px 4px', verticalAlign: 'top', width: '16px' }}
                                        />

                                        {/*<Box className="accountInitial">
                                            {this.props.auth.account.branding.logo ? (
                                                <img
                                                    src={this.props.auth.account.branding.logo}
                                                    style={{ width: '32px' }}
                                                    alt="Logo"
                                                />
                                            ) : (
                                                <div
                                                    style={{
                                                        background: 'black',
                                                        height: '100%',
                                                        width: '100%',
                                                        padding: '5px 0 0 0'
                                                    }}
                                                >
                                                    {this.props.auth.account.title.split('')[0]}
                                                </div>
                                            )}
                                        </Box>
                                        <Box>
                                            <Flex style={{ fontSize: '14px', color: '#444', maxWidth: '100%' }}>

                                            </Flex>
                                        </Box>*/}
                                    </Flex>
                                </HeaderButton>
                                {/*<HeaderButton
                                    onClick={() => {
                                        this.toggleWidth(this);
                                    }}
                                >
                                    <span className="iconWrapper">
                                        {this.state.headerExpanded == 'expanded' ? (
                                            <FiArrowLeftCircle />
                                        ) : (
                                            <FiArrowRightCircle />
                                        )}
                                    </span>
                                    <span className="textStyle">Collapse</span>
                                </HeaderButton>*/}
                            </Flex>
                        </NavBar>
                    </HeaderWidthWrapper>
                    {this.renderSubmenu()}
                </HeaderWrapper>

                <NiceModal
                    isOpen={this.state.showModalFeedback}
                    shouldCloseOnOverlayClick
                    onRequestClose={() => this.setState({ showModalFeedback: false })}
                    style={{ content: { width: 'auto', maxWidth: '1100px' } }}
                    title="Contact Us"
                >
                    <Box>
                        <Box mb={3} className="text-secondary">
                            We love making your life easier, so please let us know how we can help.
                            <br />
                            You can also email <a href={`mailto:${config.SUPPORT_EMAIL}`}>{config.SUPPORT_EMAIL}</a>.
                        </Box>
                        <Textarea
                            mb={1}
                            id="feedback-message"
                            autoFocus={1}
                            className="theme-input"
                            sx={{ minHeight: '160px' }}
                        />
                    </Box>
                    <Box className="modal-actions">
                        <Button
                            type="button"
                            variant="secondary-gray"
                            mr={3}
                            onClick={() => {
                                this.setState({ showModalFeedback: false });
                            }}
                        >
                            Cancel
                        </Button>

                        <Button type="submit" variant="primary" sx={{ marginRight: 0 }} onClick={this.submitFeedback}>
                            Send
                        </Button>
                    </Box>
                </NiceModal>

                <ProductFeedbackModal
                    isOpen={this.state.showModalProductFeedback}
                    onClose={() => this.setState({ showModalProductFeedback: false })}
                />
            </>
        );
    }
}

export default Header;
